import template from './threeDotMenu.html';

export default {
  template,
};
